module.exports = __webpack_public_path__ + "static/03-b29a5df3861f580c46dc11734092433e.jpg";